/**
 * @generated SignedSource<<a6967be943ca0672a0e2572ab6cbd78c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FiatTransactionStatus = "APPROVED" | "CANCELLED" | "CREDITED" | "FINISHED" | "INITIATED" | "MANUAL_REVIEW" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type FiatTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type FiatTransactionViewQuery$variables = {
  id?: string | null | undefined;
  offerId?: string | null | undefined;
};
export type FiatTransactionViewQuery$data = {
  readonly fiatTransaction: {
    readonly __typename: "FiatTransaction";
    readonly amount: PrecisionFloat;
    readonly createdAt: TimeScalar;
    readonly fee: PrecisionFloat;
    readonly fiat: {
      readonly id: string;
      readonly symbol: string | null | undefined;
    };
    readonly finishedAt: TimeScalar | null | undefined;
    readonly id: string;
    readonly payoutAccount: {
      readonly bankName: string | null | undefined;
      readonly iban: string;
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly refundedAt: TimeScalar | null | undefined;
    readonly rejectedAt: TimeScalar | null | undefined;
    readonly status: FiatTransactionStatus;
    readonly type: FiatTransactionType;
  } | null | undefined;
};
export type FiatTransactionViewQuery = {
  response: FiatTransactionViewQuery$data;
  variables: FiatTransactionViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      }
    ],
    "concreteType": "FiatTransaction",
    "kind": "LinkedField",
    "name": "fiatTransaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Fiat",
        "kind": "LinkedField",
        "name": "fiat",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PayoutAccount",
        "kind": "LinkedField",
        "name": "payoutAccount",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bankName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iban",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refundedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiatTransactionViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiatTransactionViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b06acb8ead0d51d744f2b448ad14086d",
    "id": null,
    "metadata": {},
    "name": "FiatTransactionViewQuery",
    "operationKind": "query",
    "text": "query FiatTransactionViewQuery(\n  $id: ID\n  $offerId: ID\n) {\n  fiatTransaction(id: $id, offerId: $offerId) {\n    __typename\n    id\n    type\n    status\n    amount\n    fee\n    fiat {\n      id\n      symbol\n    }\n    payoutAccount {\n      id\n      name\n      bankName\n      iban\n    }\n    createdAt\n    finishedAt\n    rejectedAt\n    refundedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "600779bfc1f5ec5d9d18dfc04c37fc44";

export default node;
